import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  TextField,
  Typography,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import store from "../../../redux/store";
import { login, setLang, setToken } from "../../../redux/actions";
import CustomAlert from "../../Common/Components/CustomAlert";

export function MFA(props) {
  const [value, setValue] = useState("email");
  const [secretCode, setSecretCode] = useState();
  const [inputValue, setInputValue] = useState("");
  const [isSent, setIsSent] = useState(false);

  const { t } = useTranslation(["MFA"]);

  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertType, setAlertType] = useState("error");

  const handleChange = (event) => {
    setValue(event.target.value);
  };

  const handleSend = async () => {
    let sendMethod = "email";
    let data = props.userInfo.email;

    if (value === "phone") {
      sendMethod = "SMS";
      data = props.userInfo.noTelephoneCellulaire;
    }

    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/login/code${sendMethod}/${data}`,
        {
          method: "GET",
          credentials: "include",
          headers: {
            Authorization: `Bearer ${props.token}`,
          },
        },
      );

      const code = await res.text();

      setSecretCode(code);
      setIsSent(true);

      setAlertMessage("Code sent successfully!");
      setAlertType("success");
      setAlertOpen(true);
    } catch (error) {
      setAlertMessage("Error sending code");
      setAlertType("error");
      setAlertOpen(true);
    }
  };

  const handleValidateCode = () => {
    if (inputValue.trim() === secretCode?.trim() && isSent) {
      localStorage.setItem("username", props.userInfo.userName);
      localStorage.setItem("lang", props.userInfo.langue);
      localStorage.setItem("token", props.token);

      store.dispatch(setToken(props.token));
      store.dispatch(
        login({
          username: props.userInfo.userName,
          idSession: props.idSession,
        }),
      );
      store.dispatch(setLang(props.userInfo.langue));

      window.location.reload();
    } else {
      setAlertMessage("Incorrect code");
      setAlertType("error");
      setAlertOpen(true);
    }
  };

  useEffect(() => {
    if (inputValue.trim() === secretCode?.trim() && isSent) {
      handleValidateCode();
    }
  }, [inputValue]);

  return (
    <Box
      sx={{
        width: "100%",
        maxWidth: { xs: "100%", sm: 420 },
        mx: "auto",
        p: { xs: 2, sm: 3 },

        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        gap: 2.5,

        bgcolor: "background.paper",
        borderRadius: 3,
        boxShadow: 3,

        maxHeight: "75vh",
        overflowY: "auto",
      }}
    >
      <Typography variant="h6" textAlign="center" fontWeight="bold">
        {t("WhereToSendCode")}
      </Typography>

      <FormControl>
        <RadioGroup value={value} onChange={handleChange}>
          <FormControlLabel
            value="email"
            control={<Radio />}
            label={props.userInfo.email}
            sx={{ wordBreak: "break-all" }}
          />
          {props.userInfo.noTelephoneCellulaire && (
            <FormControlLabel
              value="phone"
              control={<Radio />}
              label={props.userInfo.noTelephoneCellulaire}
            />
          )}
        </RadioGroup>
      </FormControl>

      <Button
        variant="contained"
        fullWidth
        sx={{ py: 1.2 }}
        onClick={handleSend}
      >
        Send Code
      </Button>

      {isSent && (
        <>
          <TextField
            fullWidth
            label="Code"
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            inputProps={{
              style: {
                textAlign: "center",
                fontSize: "1.8rem",
                letterSpacing: "8px",
              },
              inputMode: "numeric",
              maxLength: 6,
            }}
          />

          <Button
            variant="contained"
            color="success"
            fullWidth
            sx={{ py: 1.2 }}
            onClick={handleValidateCode}
          >
            {t("Validate")}
          </Button>
        </>
      )}

      <CustomAlert
        open={alertOpen}
        closeMessage={setAlertOpen}
        message={alertMessage}
        typeMessage={alertType}
      />
    </Box>
  );
}

export default MFA;
